<template>
  <common-framework :name="'安全管理'" :hasRightBtn="true">
    <router-view></router-view>
  </common-framework>
</template>

<script>
  // import CommonFramework from "@components/commonFramework/index";
  import CommonFramework from "@/shared/components/lyCommonFramework/index";
  export default {
    name: "safe-layout",
    components: {CommonFramework}
  }
</script>

<style scoped>

</style>
